(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('SeanceCoursSearch', SeanceCoursSearch);

    SeanceCoursSearch.$inject = ['$resource'];

    function SeanceCoursSearch($resource) {
        var resourceUrl =  'api/_search/seance-cours/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
